// eslint-disable-next-line no-use-before-define
var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};

(function ($) {
  // prodcat answers a SKU id with the sku record only, and a PRODUCT_ID with the
  // parent only (skus: 0). Both lookups are needed to build a Use It With card.
  var PRODUCT_FIELDS = [
    'PRODUCT_ID', 'PROD_RGN_NAME', 'url', 'SEO_URL', 'shaded', 'sized', 'skus'
  ];

  var SKU_FIELDS = [
    'SKU_ID', 'SKU_BASE_ID', 'PRODUCT_ID', 'product', 'path',
    'IMAGE_L_V2', 'IMAGE_M_V2', 'IMAGE_LARGE', 'IMAGE_MEDIUM', 'IMAGE_L', 'IMAGE_M',
    'LARGE_IMAGE', 'MEDIUM_IMAGE', 'IMAGE_SMOOSH_L', 'IMAGE_SMOOSH_M',
    'IMAGE_ALT_L', 'IMAGE_ALT_M', 'SHADENAME', 'HEX_VALUE_STRING', 'urlFragment',
    'DISPLAY_STATUS', 'INVENTORY_STATUS', 'DEFAULT_SKU', 'PRODUCT_SIZE',
    'formattedPrice', 'formattedPrice2', 'PRICE', 'PRICE2'
  ];

  var skuParentMap = {};
  var fetchedSkuRecords = {};
  var attemptedParentFetch = {};
  var pendingFetches = {};

  function stripSkuPrefix(id) {
    return String(id).replace(/^SKU/i, '');
  }

  function normalizeIdKey(id) {
    return stripSkuPrefix(String(id)).toUpperCase();
  }

  function isSkuId(prodId) {
    return (/^SKU\d+/i).test(prodId + '');
  }

  // 'CAT2330PROD24845SKU200830' -> 'PROD24845'
  function parentIdFromPath(record) {
    var match = record && record.path ? String(record.path).match(/PROD\d+/i) : null;

    return match ? match[0] : null;
  }

  function skuIdFromRecord(record) {
    var match;

    if (!record) { return null; }
    if (record.SKU_ID) { return record.SKU_ID; }
    match = record.path && String(record.path).match(/SKU\d+/i);

    return match ? match[0] : null;
  }

  function lookupSku(skuId) {
    return prodcat.data.getSku(stripSkuPrefix(skuId)) || prodcat.data.getSku(skuId);
  }

  function rememberSkuParent(skuId, productId) {
    if (!skuId || !productId) { return; }
    skuParentMap[normalizeIdKey(skuId)] = productId;
  }

  function rememberSkuRecord(record) {
    var id = skuIdFromRecord(record);

    if (!id) { return; }
    fetchedSkuRecords[normalizeIdKey(id)] = record;
  }

  function fetchedSkuFor(skuId) {
    return skuId ? (fetchedSkuRecords[normalizeIdKey(skuId)] || null) : null;
  }

  // A stored sku may have no PRODUCT_ID, so fall back to the cache and the path.
  function resolveParentProductId(skuId, sku) {
    if (sku && sku.PRODUCT_ID) { return sku.PRODUCT_ID; }
    if (skuParentMap[normalizeIdKey(skuId)]) { return skuParentMap[normalizeIdKey(skuId)]; }

    return parentIdFromPath(sku);
  }

  // 'SKU50326' -> 50326
  function deriveSkuBaseId(sku) {
    var digits;

    if (!sku) { return null; }
    if (sku.SKU_BASE_ID != null) { return sku.SKU_BASE_ID; }
    digits = stripSkuPrefix(sku.SKU_ID || '');

    return (/^\d+$/).test(digits) ? parseInt(digits, 10) : null;
  }

  function productNameOf(product) {
    if (!product) { return ''; }

    return product.PROD_RGN_NAME
      || product.DISPLAY_NAME
      || product.PRODUCT_NAME
      || '';
  }

  function authoritativeUrl(product) {
    return (product && (product.url || product.SEO_URL)) || '';
  }

  // 'CAT2330PROD24845SKU200830' -> '/product/2330/24845/'
  function deriveUrlFromPath(pathish) {
    var match = pathish ? String(pathish).match(/CAT(\d+)PROD(\d+)/i) : null;

    return match ? ('/product/' + match[1] + '/' + match[2] + '/') : '';
  }

  function resolveProductUrl(product, sku) {
    var skus = (product && product.skus) || [];
    var carrier;

    if (product && product.url) { return product.url; }
    if (product && product.SEO_URL) { return product.SEO_URL; }

    carrier = _.find(skus, function (candidate) {
      return candidate && candidate.product && candidate.product.url;
    });
    if (carrier) { return carrier.product.url; }

    return deriveUrlFromPath((product && product.path)
      || (sku && sku.path)
      || (skus.length && skus[0].path)
      || '');
  }

  function hasUsableProduct(productId) {
    var product = productId ? prodcat.data.getProduct(productId) : null;

    return !!(product && product.skus && product.skus.length);
  }

  // Rich enough to build a card from, as opposed to a stub carrying only a price.
  function isStoreProductComplete(product) {
    var firstSku = product && product.skus && product.skus.length ? product.skus[0] : null;

    return !!(product
      && authoritativeUrl(product)
      && productNameOf(product)
      && firstSku
      && firstSku.SKU_BASE_ID != null);
  }

  function skuMatches(candidate, skuId, sku) {
    var wanted = stripSkuPrefix(skuId);

    if (!candidate) { return false; }
    if (sku && sku.SKU_ID && candidate.SKU_ID === sku.SKU_ID) { return true; }
    if (candidate.SKU_ID != null && stripSkuPrefix(candidate.SKU_ID) === wanted) { return true; }

    return candidate.SKU_BASE_ID != null && String(candidate.SKU_BASE_ID) === wanted;
  }

  function hasUseItWithProductData(product) {
    var imageSku = product
      ? (product.defaultSku || (product.skus && product.skus.length ? product.skus[0] : null))
      : null;

    return !!(product
      && product.PRODUCT_ID
      && product.url
      && product.defaultSku
      && product.skus
      && product.skus.length
      && imageSku
      && imageSku.IMAGE_LARGE_COMBINED
      && imageSku.IMAGE_LARGE_COMBINED.length);
  }

  function normalizeSkuImages(sku, largeImageKey, mediumImageKey) {
    var normalizedSku = $.extend(true, {}, sku);

    normalizedSku.IMAGE_LARGE_COMBINED = normalizedSku[largeImageKey]
      || normalizedSku.IMAGE_SMOOSH_L
      || normalizedSku.IMAGE_ALT_L
      || [];
    normalizedSku.IMAGE_MEDIUM_COMBINED = normalizedSku[mediumImageKey]
      || normalizedSku.IMAGE_SMOOSH_M
      || normalizedSku.IMAGE_ALT_M
      || normalizedSku.IMAGE_LARGE_COMBINED;

    return normalizedSku;
  }

  // Merge the sku record from the SKU lookup over the store's copy, then backfill
  // SKU_BASE_ID. These records carry explicit nulls and empty arrays, which must
  // not overwrite good stored values ($.extend only skips undefined).
  function enrichSku(sku, largeImageKey, mediumImageKey) {
    var fetched = fetchedSkuFor(sku && sku.SKU_ID);
    var merged = $.extend(true, {}, sku);
    var normalized;

    if (fetched) {
      Object.keys(fetched).forEach(function (key) {
        var value = fetched[key];

        if (value === undefined || value === null) { return; }
        if (Array.isArray(value) && !value.length) { return; }
        merged[key] = value;
      });
    }

    normalized = normalizeSkuImages(merged, largeImageKey, mediumImageKey);

    if (normalized.SKU_BASE_ID == null) {
      normalized.SKU_BASE_ID = deriveSkuBaseId(normalized);
    }

    return normalized;
  }

  // Resolves a SKU ID from worksWith field to its parent product,
  // alongside a pinned single variant.
  function buildSkuAsProduct(skuId, largeImageKey, mediumImageKey) {
    var sku = lookupSku(skuId);
    var fetchedRecord = fetchedSkuFor(skuId);
    var parentProductId = resolveParentProductId(skuId, sku);
    var parentProduct = parentProductId ? prodcat.data.getProduct(parentProductId) : null;

    var sourceSkus;
    var normalizedSkus;
    var pinnedSku;
    var url;

    if (!parentProduct) { return null; }

    // The PRODUCT_ID lookup returns skus: 0, so a parent that was never
    // bootstrapped has no array to pin against. Build one from the sku record.
    sourceSkus = (parentProduct.skus && parentProduct.skus.length) ? parentProduct.skus : [];

    if (!sourceSkus.length) {
      if (!fetchedRecord) { return null; }
      sourceSkus = [fetchedRecord];
    }

    normalizedSkus = sourceSkus.map(function (parentSku) {
      return enrichSku(parentSku, largeImageKey, mediumImageKey);
    });

    pinnedSku = _.find(normalizedSkus, function (parentSku) {
      return skuMatches(parentSku, skuId, sku);
    });

    if (!pinnedSku && fetchedRecord) {
      pinnedSku = enrichSku(fetchedRecord, largeImageKey, mediumImageKey);
      normalizedSkus = normalizedSkus.concat([pinnedSku]);
    }

    if (!pinnedSku) { return null; }

    url = resolveProductUrl(parentProduct, sku);
    rememberSkuParent(skuId, parentProductId);

    return {
      // Only an authoritative url is stored; a derived one would look real on
      // the next pass and suppress the refetch.
      storeProduct: $.extend(true, {}, parentProduct, {
        skus: normalizedSkus,
        url: authoritativeUrl(parentProduct)
      }),
      renderProduct: $.extend(true, {}, parentProduct, {
        skus: [pinnedSku],
        defaultSku: pinnedSku,
        sku_as_product: true,
        sku_count: 0,
        url: url
      })
    };
  }

  function getUseItWithProducts(productIds, globalVariables) {
    var hasResponsiveImages = globalVariables && globalVariables.product_responsive_images;
    var largeImageKey = hasResponsiveImages ? 'IMAGE_LARGE' : 'IMAGE_L_V2';
    var mediumImageKey = hasResponsiveImages ? 'IMAGE_MEDIUM' : 'IMAGE_M_V2';

    return productIds.map(function (prodId) {
      var built;

      if (isSkuId(prodId)) {
        built = buildSkuAsProduct(prodId, largeImageKey, mediumImageKey);

        return built ? built.renderProduct : null;
      }

      return prodcat.data.getProduct(prodId);
    }).filter(hasUseItWithProductData);
  }

  function normalizeUseItWithProducts(productIds, globalVariables) {
    var hasResponsiveImages = globalVariables && globalVariables.product_responsive_images;
    var largeImageKey = hasResponsiveImages ? 'IMAGE_LARGE' : 'IMAGE_L_V2';
    var mediumImageKey = hasResponsiveImages ? 'IMAGE_MEDIUM' : 'IMAGE_M_V2';
    var storeUpdates = [];

    productIds.forEach(function (prodId) {
      var product;
      var built;

      if (isSkuId(prodId)) {
        built = buildSkuAsProduct(prodId, largeImageKey, mediumImageKey);
        if (built) { storeUpdates.push(built.storeProduct); }

        return;
      }

      product = prodcat.data.getProduct(prodId);

      if (!product || !product.skus || !product.skus.length) { return; }

      product.skus = product.skus.map(function (sku) {
        return enrichSku(sku, largeImageKey, mediumImageKey);
      });
      product.defaultSku = _.find(product.skus, function (sku) {
        return sku.DEFAULT_SKU === 1;
      }) || product.skus[0];
      product.sku_count = product.skus.length <= 1 ? 0 : product.skus.length;
      product.url = product.url || product.SEO_URL || '';

      storeUpdates.push(product);
    });

    if (storeUpdates.length) {
      prodcat.data.updateProducts(storeUpdates, true);
    }
  }

  function partitionRecords(records) {
    var products = [];
    var skus = [];

    (records || []).forEach(function (record) {
      if (!record) { return; }
      if (record.skus && record.skus.length) { products.push(record); }
      else { skus.push(record); }
    });

    return { products: products, skus: skus };
  }

  // A sku record carries its parent's PRODUCT_ID, so that alone proves nothing.
  function looksLikeParentProduct(record) {
    if (!record) { return false; }
    if (record.skus && record.skus.length) { return true; }

    return !!(record.PRODUCT_ID && !record.SKU_ID && productNameOf(record));
  }

  function requestProdcatIndividually(ids, onDone) {
    var results = [];
    var remaining = ids.length;

    ids.forEach(function (id) {
      // eslint-disable-next-line no-use-before-define
      requestProdcat([id], function (records) {
        results = results.concat(records);
        remaining -= 1;
        if (remaining <= 0) {
          onDone(results);
        }
      });
    });
  }

  function requestProdcat(ids, onDone) {
    generic.jsonrpc.fetch({
      method: 'prodcat',
      params: [{
        products: ids,
        product_fields: PRODUCT_FIELDS,
        sku_fields: SKU_FIELDS
      }],
      onSuccess: function (r) {
        var data = r.getValue();

        onDone((data && data.products) || []);
      },
      onFailure: function () {
        /*
          A single invalid id fails the ENTIRE batch RPC call; retry one
          id at a time so valid siblings still resolve.
        */
        if (ids.length > 1) {
          requestProdcatIndividually(ids, onDone);

          return;
        }
        onDone([]);
      }
    });
  }

  function fetchParentProducts(parentIds, onDone) {
    if (!parentIds.length) {
      onDone();

      return;
    }

    requestProdcat(parentIds, function (records) {
      var storable = (records || []).filter(looksLikeParentProduct);

      if (storable.length) {
        prodcat.data.updateProducts(storable, true);
      }

      onDone();
    });
  }

  function fetchMissingUseItWithData(skuIds, productIds, onComplete) {
    var requestIds = skuIds.concat(productIds);
    var key = requestIds.slice().sort().join(',');
    var parentIds = [];
    var finish;

    function considerParent(parentId) {
      if (!parentId || parentIds.indexOf(parentId) !== -1) { return; }
      if (isStoreProductComplete(prodcat.data.getProduct(parentId))) { return; }

      parentIds.push(parentId);
    }

    if (!requestIds.length) {
      onComplete();

      return;
    }

    if (pendingFetches[key]) {
      pendingFetches[key].push(onComplete);

      return;
    }
    pendingFetches[key] = [onComplete];

    // One attempt per parent per page load.
    skuIds.forEach(function (skuId) {
      var parentId = resolveParentProductId(skuId, lookupSku(skuId));

      if (parentId) { attemptedParentFetch[parentId] = true; }
      considerParent(parentId);
    });
    productIds.forEach(function (productId) {
      attemptedParentFetch[productId] = true;
      considerParent(productId);
    });

    finish = function () {
      var callbacks = pendingFetches[key] || [];

      delete pendingFetches[key];
      callbacks.forEach(function (callback) { callback(); });
    };

    if (!skuIds.length) {
      fetchParentProducts(parentIds, finish);

      return;
    }

    // The SKU lookup is the only source of SKU_BASE_ID, SHADENAME,
    // HEX_VALUE_STRING and PRODUCT_SIZE, so it runs for every missing sku.
    requestProdcat(skuIds, function (records) {
      var split = partitionRecords(records);

      if (split.products.length) {
        prodcat.data.updateProducts(split.products, true);
        split.products.forEach(function (product) {
          considerParent(product.PRODUCT_ID);
        });
      }

      if (split.skus.length) {
        prodcat.data.updateSkus(split.skus);
      }

      split.skus.forEach(function (record) {
        var parentId = record.PRODUCT_ID || parentIdFromPath(record);

        rememberSkuRecord(record);
        rememberSkuParent(skuIdFromRecord(record), parentId);
        considerParent(parentId);
      });

      fetchParentProducts(parentIds, finish);
    });
  }

  Drupal.behaviors.productFullDetailsV2 = {
    attached: false,
    /* eslint-disable complexity */
    attach: function (context, settings) {
      var self = this;
      var $detailsSection = $('.js-product-full-details', context);
      var $expanderSections = $('.js-product-full-details__data-section', $detailsSection);
      var $heading = $('.js-product-full-details__data-heading', $detailsSection);
      var $otherContent = $('.js-product-full-details__data-content', $detailsSection);
      var $productFull = $detailsSection.closest('.js-product-full');
      var mainProductId = $productFull.attr('data-product-id');
      var renderingUseItWith = false;

      if (self.attached) {
        return;
      }
      self.attached = true;

      // worksWith SKU level field holds SKU IDs, and these cards render sku_as_product, so the
      // pinned SKU is part of the identity — not just the product.
      function renderedCardSignature() {
        var pairs = [];

        $detailsSection
          .find('.js-product-full-details__data-section--use-it-with [data-product-id]')
          .each(function () {
            var $node = $(this);
            var productId = $node.attr('data-product-id');
            var skuBaseId = $node.attr('data-sku-base-id');
            var pair;

            if (!productId) { return; }
            pair = productId + ':' + (skuBaseId == null ? '' : String(skuBaseId));

            if (pairs.indexOf(pair) === -1) { pairs.push(pair); }
          });

        return pairs;
      }

      function incomingCardSignature(products) {
        return products.map(function (product) {
          var baseId = product.defaultSku && product.defaultSku.SKU_BASE_ID != null
            ? String(product.defaultSku.SKU_BASE_ID)
            : '';

          return product.PRODUCT_ID + ':' + baseId;
        });
      }

      function sameSignature(a, b) {
        if (a.length !== b.length) { return false; }

        return a.slice().sort().join(',') === b.slice().sort().join(',');
      }

      function serverAtbBranch() {
        var $section = $detailsSection
          .find('.js-product-full-details__data-section--use-it-with');

        if (!$section.length) { return null; }

        return $section.is('.js-use-with-atb-section')
          || $section.find('.js-use-with-atb-section').length > 0
          || $section.find('.js-use-it-with-atb-info').length > 0
          || $section.find('.js-use-with-atb-link').length > 0;
      }

      function renderUseItWith(worksWithIds, skuData) {
        var useItWithData = getUseItWithProducts(worksWithIds, settings.global_variables);
        var parentProduct = prodcat.data.getProduct(skuData.PRODUCT_ID);
        var existing = renderedCardSignature();
        var incoming = incomingCardSignature(useItWithData);
        var rawAtb;
        var templateGlobals;
        var templateConfig;
        var rendered;
        var $renderedUseItWith;
        var $existingUseItWith;
        var $useItWithContainer;

        // The markup on the page at load is server-rendered and complete;
        // rebuilding it identically would be a downgrade, not an update.
        if (existing.length && sameSignature(existing, incoming)) {
          return;
        }
        if (renderingUseItWith) {
          return;
        }

        rawAtb = settings.global_variables
          ? settings.global_variables.use_it_with_add_to_bag
          : undefined;

        templateGlobals = {
          t: site.translations,
          variables: $.extend({}, settings.global_variables, {
            use_it_with_add_to_bag: (rawAtb === undefined || rawAtb === null)
              ? Boolean(serverAtbBranch())
              : Boolean(rawAtb)
          })
        };

        templateConfig = {
          // The template reads globals from inside {{# use_with }} > {{# skus.0 }},
          // so it is attached at those context levels too. Copies only.
          use_with: useItWithData.map(function (product) {
            var copy = $.extend({}, product, { globals: templateGlobals });

            if (copy.skus && copy.skus.length) {
              copy.skus = copy.skus.map(function (sku) {
                return $.extend({}, sku, { globals: templateGlobals });
              });
            }
            if (copy.defaultSku) {
              copy.defaultSku = $.extend({}, copy.defaultSku, { globals: templateGlobals });
            }

            return copy;
          }),
          use_it_with_shaded_title: Boolean(parentProduct && parentProduct.shaded),
          globals: templateGlobals
        };

        rendered = site.template.get({
          name: 'use_it_with_v1',
          data: templateConfig
        });

        if (!rendered) { return; }

        $renderedUseItWith = $(rendered);

        if (!$renderedUseItWith.length) { return; }

        $existingUseItWith = $detailsSection
          .find('.js-product-full-details__data-section--use-it-with');
        $useItWithContainer = $detailsSection.find('.product-full-details__data-details');

        if (!$existingUseItWith.length && !$useItWithContainer.length) {
          return;
        }

        renderingUseItWith = true;
        if ($existingUseItWith.length) {
          $existingUseItWith.replaceWith($renderedUseItWith);
        } else {
          $useItWithContainer.append($renderedUseItWith);
        }

        // Re-bind JS behaviors for newly rendered sub-templates (shades/size/select components).
        if (Drupal.attachBehaviors && $renderedUseItWith.get(0)) {
          Drupal.attachBehaviors($renderedUseItWith.get(0), settings);
        }

        // Re-apply default state for shade components after the DOM replacement.
        $(document).trigger('products.init-finish');
        renderingUseItWith = false;
      }

      function handleSkuSelect(skuId) {
        var skuData = skuId ? prodcat.data.getSku(skuId) : null;
        var worksWithIds = skuData ? skuData.worksWith : null;
        var missingSkuIds;
        var missingProductIds;

        if (!settings.global_variables || !settings.global_variables.use_it_with_by_sku) {
          return;
        }
        if (!worksWithIds || !worksWithIds.length) { return; }

        normalizeUseItWithProducts(worksWithIds, settings.global_variables);

        missingSkuIds = worksWithIds.filter(function (prodId) {
          var targetSku;
          var parentId;

          if (!isSkuId(prodId)) { return false; }
          targetSku = lookupSku(prodId);
          if (!targetSku || targetSku.SKU_BASE_ID == null) { return true; }
          parentId = resolveParentProductId(prodId, targetSku);

          if (!parentId || !hasUsableProduct(parentId)) { return true; }

          return !attemptedParentFetch[parentId]
            && !isStoreProductComplete(prodcat.data.getProduct(parentId));
        });

        missingProductIds = worksWithIds.filter(function (prodId) {
          if (isSkuId(prodId)) { return false; }

          return !hasUseItWithProductData(prodcat.data.getProduct(prodId));
        });

        if (missingSkuIds.length || missingProductIds.length) {
          fetchMissingUseItWithData(missingSkuIds, missingProductIds, function () {
            normalizeUseItWithProducts(worksWithIds, settings.global_variables);
            renderUseItWith(worksWithIds, skuData);
          });

          return;
        }

        renderUseItWith(worksWithIds, skuData);
      }

      $productFull.on('product.skuSelect', function (e, skuId) {
        var skuData = skuId ? prodcat.data.getSku(skuId) : null;

        if (renderingUseItWith || !skuData
          || String(skuData.PRODUCT_ID) !== String(mainProductId)) {
          return;
        }
        handleSkuSelect(skuId);
      });

      // product.skuSelect does not always fire on load. Called directly rather
      // than triggered, so no other listener sees a synthetic event.
      function primeUseItWith() {
        var productId;
        var product;
        var skuBaseId;

        if (renderedCardSignature().length) { return; }

        productId = $productFull.attr('data-product-id');
        product = productId ? prodcat.data.getProduct(productId) : null;
        skuBaseId = $productFull.attr('data-sku-base-id')
          || $('.js-sticky-add-to-bag').attr('data-sku-base-id')
          || (product && product.defaultSku && product.defaultSku.SKU_BASE_ID != null
            ? String(product.defaultSku.SKU_BASE_ID)
            : '');

        if (skuBaseId) { handleSkuSelect(skuBaseId); }
      }

      /*
        Deferred: the initial pass runs inside the same synchronous
        Drupal.attachBehaviors(document) loop as productFullShadesV2; a
        nested attachBehaviors call here would consume its one-time
        "attached" flag before it binds the visible swatch handlers.
      */
      setTimeout(primeUseItWith, 0);
      $(document).one('products.init-finish', function () {
        setTimeout(primeUseItWith, 0);
      });

      // Section expanders
      if ($expanderSections.length) {
        $expanderSections.each(function () {
          var $this = $(this);
          var $triggerHead = $this.find($heading);
          var callback = function () {
            var $content = $triggerHead.next('.js-product-full-details__data-content');
            var expanded = $this.attr('aria-expanded') === 'true' ? false : true;

            if ($triggerHead.attr('aria-expanded') === 'true') {
              $triggerHead.attr('aria-expanded', 'false');
              $content.attr('aria-hidden', 'true').addClass('hidden');
            }
            else {
              $triggerHead.attr('aria-expanded', 'true');
              $content.attr('aria-hidden', 'false').removeClass('hidden');
            }
          };

          // Click handler
          $triggerHead.on('click', callback).on('keydown', function (e) {
            e.preventDefault();
            callback(e, this);
          });
        });
      }
    }
  };

  $(document).on('useitwith.skuSelect', function (e, skuBaseId, $node) {
    var $addToCartButton = $node.find('.js-use-with-atb-link');
    var skuData = prodcat.data.getSku(skuBaseId);
    var selectedSkuImage = skuData?.IMAGE_MEDIUM_COMBINED?.[0] || 0;
    var $formattedPrice = $node.find('.js-new-price');
    var $oldFormattedPrice = $node.find('.js-old-price');

    if (typeof skuBaseId !== 'undefined') {
      if ($addToCartButton.length) {
        $addToCartButton.attr('data-sku-base-id', skuBaseId);
      }
    }
    if (selectedSkuImage) {
      $node.prev('.js-use-it-with-img-wrap').find('img').attr('src', selectedSkuImage);
    }
    if ($formattedPrice.length && skuData?.formattedPrice) {
      $formattedPrice.text(skuData.formattedPrice);
    }
    if ($oldFormattedPrice.length && skuData?.formattedPrice2) {
      $oldFormattedPrice.text(skuData.formattedPrice2);
      $formattedPrice.addClass('price-discount');
    } else {
      $formattedPrice.removeClass('price-discount');
      $oldFormattedPrice.text('');
    }
    $(document).trigger('useitwith.updateInventory', [$node, skuData]);
  });

  $(document).on('useitwith.sizeSelect', function (e, data, $node) {
    const skuData = data || {};
    var $addToCartButton = $node.find('.js-use-with-atb-link');
    var $formattedPrice = $node.find('.js-new-price');
    var $oldFormattedPrice = $node.find('.js-old-price');
    var $productSize = $node.find('.js-product-size-atb');
    var selectedSkuData = prodcat.data.getSku(skuData.skuBaseId);
    var selectedSkuImage = selectedSkuData?.IMAGE_MEDIUM_COMBINED?.[0] || 0;

    if ($addToCartButton.length && skuData.skuBaseId !== 'undefined') {
      $addToCartButton.attr('data-sku-base-id', skuData.skuBaseId);
    }
    if ($formattedPrice.length && skuData.price !== undefined) {
      $formattedPrice.text(skuData.price);
    }
    if ($oldFormattedPrice.length && skuData.oldPrice) {
      $oldFormattedPrice.text(skuData.oldPrice);
      $formattedPrice.addClass('price-discount');
    } else {
      $formattedPrice.removeClass('price-discount');
      $oldFormattedPrice.text('');
    }
    if ($productSize.length && skuData.productSize !== undefined) {
      $productSize.text(skuData.productSize);
    }
    if (selectedSkuImage) {
      $node.prev('.js-use-it-with-img-wrap').find('img').attr('src', selectedSkuImage);
    }
    $(document).trigger('useitwith.updateInventory', [$node, selectedSkuData]);
  });

  $(document).on('products.init-finish', function () {
    var $shadedProducts = $('.js-use-with-shaded');

    if (!$shadedProducts.length) {
      return;
    }

    $shadedProducts.each(function () {
      var $shadedProduct = $(this);
      var $findDefaultOption = $shadedProduct.find('[data-default-sku="true"]');
      var $setDefaultOption = $findDefaultOption.length > 0
        ? $findDefaultOption
        : $shadedProduct.find('.js-shade-select-option').first();

      if ($setDefaultOption.length) {
        const skuBaseId = $setDefaultOption.data('sku-base-id');
        const $select = $setDefaultOption.closest('.js-shade-select');
        const $hidden = $select.find('.js-shade-select-hidden');
        const labelText = $setDefaultOption.find('.js-shade-select-label').text().trim();
        const hex = $setDefaultOption.find('.js-shade-select-color').data('hex-value');

        $select.find('.js-shade-select-option').removeClass('selected').attr('aria-selected', false);
        $setDefaultOption.addClass('selected').attr('aria-selected', true);

        $hidden.val(skuBaseId).trigger('change');

        $select.find('.js-shade-select-label-text').text(labelText);
        $select.find('.js-shade-select-label-color').css('background-color', hex);
      }
    });
  });

  $(document).on('click', '.js-use-with-atb', function (e) {
    e.preventDefault();
    var $addBtn = $(this);
    var skuBaseId = $addBtn.attr('data-sku-base-id');
    var args = {};

    args.skuBaseId = skuBaseId;
    args.add_to_cart = 1;
    args.action = 'add';
    args.INCREMENT = 1;

    prodcat.ui.addToCart(args, $addBtn);
  });

  $(document).on('useitwith.updateInventory', function (e, $node, skuData) {
    var $addToCartButton = $node.find('.js-use-with-atb-link');
    var $inventoryStatus = $node.find('.js-use-with-inventory-status');
    var $soldOutLink = $node.find('.js-use-with-atb-sold-out');

    if ($inventoryStatus.length && skuData?.INVENTORY_STATUS === 2) {
      $inventoryStatus.removeClass('hidden');
    } else {
      $inventoryStatus.addClass('hidden');
    }
    if ($soldOutLink.length && skuData?.INVENTORY_STATUS === 7) {
      $soldOutLink.removeClass('hidden');
      $addToCartButton?.addClass('hidden');
    } else {
      $soldOutLink.addClass('hidden');
      $addToCartButton?.removeClass('hidden');
    }
  });
})(jQuery);
